export enum LocalSettings {
  MapType = 'mapType',
  MarkersType = 'MarkersType',
  AutoCalibration = 'autoCalibration',
  SnapToRoad = 'snapToRoad',
  IntervalPlacing = 'intervalPlacing',
  IntervalMeters = 'intervalMeters',
  CustomIdGeneration = 'customIdGeneration',
  DarkMode = 'darkMode',
  MoreFiltersExpanded = 'moreFiltersExpanded',

  SelectedOwner = 'selectedOwner',
  SelectedProject = 'selectedProject',
}
